import React, { useMemo } from "react";
import { Box, AppBar, Toolbar, Typography } from "@mui/material";
import { useLocation, useParams } from "react-router";
import { useUserInfo } from "../../hooks/useUserInfo";
import useSession from "../../hooks/useSession";
import { getAllowedTableauReports } from "../../utils/tableauConfig"; 

const TopBar = () => {
  const location = useLocation();
  const { reportPath } = useParams();

  const { parsedTenantAttribute, tenant } = useUserInfo();
  const { rolesSet } = useSession();

  const reports = useMemo(
    () => getAllowedTableauReports(parsedTenantAttribute, rolesSet),
    [parsedTenantAttribute, rolesSet]
  );

  const activeReportLabel = useMemo(() => {
    if (!reportPath) return null;
    return reports.find((r) => r.path === reportPath)?.label || null;
  }, [reports, reportPath]);


  const isReportsRoute = location.pathname.includes("/analytics/reports");

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        color="primary"
        sx={(theme) => ({
          boxShadow: "none",
          borderBottom: `1px solid ${theme.palette.border?.main || "#eee"}`,
          backgroundColor: theme.palette.backgroundPrimary.main,
          color: "black",
        })}
      >
        <Toolbar sx={{ minHeight: 56 }}>
          {/* Breadcrumb */}
          <Typography variant="body2" color="text.secondary">
           {"Client Portal"}
          </Typography>

          {isReportsRoute && (
            <>
              <Typography variant="body2" color="text.secondary" sx={{ mx: 1 }}>
                ›
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Analytics
              </Typography>
            </>
          )}

          {activeReportLabel && (
            <>
              <Typography variant="body2" color="text.secondary" sx={{ mx: 1 }}>
                ›
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                {activeReportLabel}
              </Typography>
            </>
          )}

          {/* Spacer */}
          <Box sx={{ flexGrow: 1 }} />

        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default TopBar;
